import { all } from "redux-saga/effects";
import { chieuCaoCanNangSaga } from "./chieuCaoCanNangSaga";

export default function* danThuocSagaWrapper() {
    yield all([
        chieuCaoCanNangSaga()
    ])
}